export var PromoCodeType;
(function (PromoCodeType) {
    PromoCodeType["FreeAccess"] = "free_access";
    PromoCodeType["Discount"] = "discount";
})(PromoCodeType || (PromoCodeType = {}));
export var PromoCodeDuration;
(function (PromoCodeDuration) {
    PromoCodeDuration["Weekly"] = "weekly";
    PromoCodeDuration["TwoWeek"] = "two_week";
    PromoCodeDuration["Monthly"] = "monthly";
    PromoCodeDuration["TwoMonth"] = "two_month";
    PromoCodeDuration["ThreeMonth"] = "three_month";
    PromoCodeDuration["SixMonth"] = "six_month";
    PromoCodeDuration["Yearly"] = "yearly";
    PromoCodeDuration["Lifetime"] = "lifetime";
})(PromoCodeDuration || (PromoCodeDuration = {}));
export const PROMO_CODE_PATTERN = /^[A-Z0-9][A-Z0-9_-]{2,31}$/;
export const STANDARD_PLAN_PACKAGE_IDENTIFIERS = [
    '$rc_monthly',
    '$rc_annual',
    'biz_monthly',
    'biz_annual',
];
//# sourceMappingURL=promo-code.const.js.map